<div class="mt-7 flex flex-col justify-around gap-7 lg:mt-24 2xl:flex-row">
    <div class="place-self-center xl:place-self-start">
        <div
            class="border-primary bg-primary/5 mb-12 max-w-90 min-w-90 rounded-lg border p-4 lg:max-w-118 lg:min-w-118"
        >
            <div class="mb-6 text-center">
                <span class="lg:text-headline-large text-title-large">
                    {{ adPackagesBlock().translations_refs | getTranslation: "title" }}
                </span>
            </div>

            <div class="flex flex-col gap-4">
                @for (feature of packagesFeatures(); track feature.id) {
                    <div class="flex items-center gap-3">
                        <svg-icon
                            class="text-success"
                            [svgStyle]="{ width: '24px', height: '24px' }"
                            src="assets/icons/Check-Circle-1.svg"
                        />
                        <span class="text-body-small">{{ feature.translations_refs | getTranslation: "title" }}</span>
                    </div>
                }
            </div>
        </div>

        <div class="flex flex-col gap-4">
            @for (adPackage of adPackages(); track adPackage.id) {
                <div
                    class="border-primary bg-primary/5 max-w-90 min-w-90 rounded-lg border p-4 lg:max-w-118 lg:min-w-118"
                >
                    <div class="mb-6 flex items-center justify-center gap-3 text-center">
                        <span
                            class="border-primary text-primary flex size-7 items-center justify-center rounded-full border-2"
                        >
                            <span class="text-title-large">{{ adPackage.id }}</span>
                        </span>
                        <span class="text-title-large">{{
                            adPackage.translations_refs | getTranslation: "title"
                        }}</span>
                    </div>

                    <div class="flex flex-col gap-4 text-center">
                        <span class="text-body-small">
                            {{ adPackage.translations_refs | getTranslation: "subtitle" }}
                        </span>
                        <div class="flex items-center justify-center gap-2">
                            <span class="text-body-large">{{ adPackage.price | currency: "" : "" : "1.0-0" }}$</span>
                            <span class="text-body-large">/ {{ "ad_packages_block.yearly" | transloco }}</span>
                        </div>

                        @if (adPackage | sanitizeAdPackage; as link) {
                            <a
                                [href]="link.url"
                                target="_blank"
                                class="text-body-small bg-primary w-fit place-self-center rounded-md px-4 py-2 text-center text-white"
                            >
                                {{ "ad_packages_block.buy" | transloco }}
                            </a>
                        }
                    </div>
                </div>
            }
        </div>
    </div>

    <div class="mt-7 flex grow flex-col items-start justify-center gap-4 lg:mt-0">
        <div
            class="border-primary/20 inline-flex max-w-90 min-w-90 justify-center place-self-center rounded-md border bg-white lg:w-fit"
        >
            @for (button of buttons(); track button.id) {
                <button
                    type="button"
                    (click)="button.onClick()"
                    [class]="
                        button.isActive
                            ? 'bg-primary text-body-small inline-flex min-w-45 items-center justify-center rounded p-3 font-medium text-white transition-all'
                            : 'text-primary hover:bg-primary/5 text-body-small inline-flex min-w-45 items-center justify-center rounded p-3 font-medium transition-all'
                    "
                >
                    <svg-icon
                        [class]="button.isActive ? 'mr-1.5 text-white' : 'text-primary mr-1.5'"
                        [svgStyle]="{ width: '16px', height: '16px' }"
                        [src]="button.icon"
                    />
                    {{ button.translationKey | transloco }}
                </button>
            }
        </div>

        <figure
            class="mb-7 flex max-w-90 min-w-90 content-start items-start justify-start place-self-center lg:mb-auto lg:w-full lg:max-w-full lg:min-w-full lg:place-self-start"
        >
            <img
                [ngSrc]="currentImage() | getDirectusImage"
                width="2000"
                height="1000"
                [alt]="adPackagesBlock().translations_refs | getTranslation: 'title'"
                class="w-full object-contain"
            />
        </figure>
    </div>
</div>
